export function subscribeBoxSwitch() {
    $('#subEmailSpan').before('<input id="subEmail" name="subEmail" type="email" class="form-control footer__email-input" placeholder="Enter email address" required>');
    $('#subEmail').on('keypress', (ev) => {
        if (ev.keyCode === 13) {
            ev.preventDefault();
        }
    });
    $('#subEmail').select();
    $('.footer__email-btn').prop('disabled', false);
    $('#subEmailSpan').remove();
}
